<template>
    <div>
        <video ref="videoPlayer" class="video-js"></video>
    </div>
</template>

<script>
import videojs from 'video.js';

export default {
    name: "VideoPlayer",
    props: {
        options: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            player: null
        }
    },
    mounted() {
        this.player = videojs(this.$refs.videoPlayer, this.options, function onPlayerReady() {
        })
    },
    beforeDestroy() {
        if (this.player) {
            this.player.dispose()
        }
    }
}
</script>

<style scoped>
  #resizer,
  footer {
    background-color: #ECEEF1;
    color: #868688;
    padding: 3px 10px;
  }

  .footer-text {
    padding: 3px;
    display: block; 
  }

  footer .copyright {
    float: left;
  }

  footer .other-links {
    margin: 0;
    padding: 0;
    float: right;
  }

  footer .other-links li {
    display: inline;
  }

  footer .logo {
    display: none;
  }
</style>